import React from 'react'
import { Spinner } from 'react-rainbow-components'
import './loading.scss'

const Loading: React.FC = () => (
  <div className="loading">
    <Spinner size="large" />
  </div>
)
export default Loading